import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_NORMAL_getInstance1njykag03saqj as Codes_NORMAL_getInstance,
  Codes_INTERNAL_ERROR_getInstance3v6rjxm79q45d as Codes_INTERNAL_ERROR_getInstance,
} from './CloseReason.mjs';
import { Close3tx65evcwi73t as Close } from './Frame.web.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *send(frame, $completion) {
  yield* this.d5b().b1b(frame, $completion);
  return Unit_instance;
}
var WebSocketSessionClass;
function WebSocketSession() {
  if (WebSocketSessionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WebSocketSession', VOID, VOID, VOID, [1, 0]);
    WebSocketSessionClass = $;
  }
  return WebSocketSessionClass;
}
function *close(_this__u8e3s4, reason, $completion) {
  reason = reason === VOID ? CloseReason().w5a(Codes_NORMAL_getInstance(), '') : reason;
  try {
    yield* _this__u8e3s4.e5b(Close().c5c(reason), $completion);
    yield* _this__u8e3s4.g4k($completion);
  } catch ($p) {
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *closeExceptionally(_this__u8e3s4, cause, $completion) {
  var tmp;
  if (cause instanceof CancellationException()) {
    tmp = CloseReason().w5a(Codes_NORMAL_getInstance(), '');
  } else {
    tmp = CloseReason().w5a(Codes_INTERNAL_ERROR_getInstance(), cause.toString());
  }
  var reason = tmp;
  yield* /*#__NOINLINE__*/close(_this__u8e3s4, reason, $completion);
  return Unit_instance;
}
//region block: exports
export {
  send as send3vgnni2smbra3,
  closeExceptionally as closeExceptionally478f4pam77tz,
  close as close2zjubq94ny3dk,
  WebSocketSession as WebSocketSessionzi1ianvyj32u,
};
//endregion

//# sourceMappingURL=WebSocketSession.mjs.map
